require('../modules/web.url');
require('../modules/web.url.to-json');
require('../modules/web.url-search-params');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/url.js
// module id = 585
// module chunks = 4